/** Libellés des statuts workflow incident (case_incidents.status). */
export function getIncidentWorkflowLabel(status) {
  const labels = {
    open: 'Nouveau',
    in_progress: 'En cours de traitement',
    resolved: 'Fermé',
  };
  return labels[status] || status || '—';
}
